/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type HeaderDesktopQueryVariables = {
    id: string;
};
export type HeaderDesktopQueryResponse = {
    readonly User_by_pk: {
        readonly id: string;
    } | null;
};
export type HeaderDesktopQuery = {
    readonly response: HeaderDesktopQueryResponse;
    readonly variables: HeaderDesktopQueryVariables;
};



/*
query HeaderDesktopQuery(
  $id: String!
) {
  User_by_pk(id: $id) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "User_by_pk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HeaderDesktopQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HeaderDesktopQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "255c782c160abe97518328e70e9629ba",
    "id": null,
    "metadata": {},
    "name": "HeaderDesktopQuery",
    "operationKind": "query",
    "text": "query HeaderDesktopQuery(\n  $id: String!\n) {\n  User_by_pk(id: $id) {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '8dcbfa7c26f84e8bc6415c2ad3a4b3ff';
export default node;
